import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

export const getUseShippingAddress = (cartId: CartId) => (state: RootState) => {
  const slice = state.quote.useShippingAddress[cartId ?? '']
  return !!(slice?.value)
}
